module.exports = __webpack_public_path__ + "static/media/4ODA15.856ef18b.jpg";